// store/modules/payments.js

export default {
    namespaced: true,

    state: () => ({
        payments: [],
        connected: false,
        lastPayment: null,
        drawerOpen: false,
    }),

    getters: {

        payments: state => state.payments,

        connected: state => state.connected,

        lastPayment: state => state.lastPayment,

        drawerOpen: state => state.drawerOpen,

    },

    mutations: {

        SET_STATE(state, payload){
            for (const key in payload) {
                if (payload.hasOwnProperty(key) && key in state) {
                    state[key] = payload[key];
                }
            }
        },

        SET_CONNECTED(state, value) {
            state.connected = value;
        },

        ADD_PAYMENT(state, payment) {
            state.payments.unshift({
                ...payment,
                posted: "No"
            });

            state.lastPayment = payment;

            if(state.payments.length>100){
                state.payments.pop();
            }
        },

        TOGGLE_DRAWER(state) {
            state.drawerOpen = !state.drawerOpen;
        },

        OPEN_DRAWER(state) {
            state.drawerOpen = true;
        },

        CLOSE_DRAWER(state) {
            state.drawerOpen = false;
        },


        CLEAR(state) {
            state.payments = [];
            state.lastPayment = null;
            state.drawerOpen = false;

        }

    },

    actions: {
        updateState({ commit }, newState) {
            commit('SET_STATE', newState);
        },
        addPayment({state, commit }, payment) {
            commit("ADD_PAYMENT", payment);
        },

        TOGGLE_DRAWER(state) {
            state.drawerOpen = !state.drawerOpen;
        },

        OPEN_DRAWER(state) {
            state.drawerOpen = true;
        },

        CLOSE_DRAWER(state) {
            state.drawerOpen = false;
        },

        clear({ commit }) {
            commit("CLEAR");
        },

        setConnected({ commit }, value) {
            commit("SET_CONNECTED", value);
        }

    }

}